<!--suppress HtmlUnknownTag -->
<vuejs3-todo>
    Remove functional attribute
</vuejs3-todo>

<template functional>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "App"
    }
</script>

<style lang="scss">
    @import "../variables";
    @import "../colors";

    body {
        margin: 0;
        padding: 0;
        color: $color-font-dark;
        font-size: 14px;
        line-height: 20px;
        font-family: $font-family;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
